/**
 * Kasse custom-period fields. Stored value stays YYYY-MM-DD.
 * Swap the display for the shared clinic date helper when that lands (draft #481).
 */
import { formatDanishCivilDate, parseDanishCivilDate } from '@/lib/danishDate';

export const KASSE_DATE_PLACEHOLDER = 'dd-mm-åååå';

export function formatKasseDate(civil: string | null | undefined): string {
  return formatDanishCivilDate(civil);
}

export function parseKasseDate(text: string): string | null {
  return parseDanishCivilDate(text);
}
